import React, { useEffect, useState } from 'react';
import { QuoteIcon } from 'lucide-react';
export const TestimonialsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('testimonials');
      if (element) {
        const position = element.getBoundingClientRect();
        if (position.top < window.innerHeight * 0.75) {
          setIsVisible(true);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on initial load
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const testimonials = [{
    name: 'Emily R.',
    title: 'Voice Coach, Chicago',
    quote: "I've been waiting for a platform like this — clean, simple, and focused just on music."
  }, {
    name: 'Daniel M.',
    title: 'Piano Teacher, Los Angeles',
    quote: 'MaestroConnect gives me everything I need to manage lessons, track progress, and stay organized — all in one place.'
  }, {
    name: 'Tanya S.',
    title: 'Violin Instructor, NYC',
    quote: "As a violin instructor, I'm excited to join a network that actually understands musicians."
  }];
  return <section id="testimonials" className="py-24 bg-navy-900 relative overflow-hidden" data-id="element-12391">
      <div className="absolute inset-0 z-0" data-id="element-12392">
        <div className="absolute inset-0 bg-gradient-to-b from-navy-900 via-navy-800 to-navy-900 opacity-90" data-id="element-12393"></div>
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1511379938547-c1f69419868d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')] bg-cover bg-center opacity-10" data-id="element-12394"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-12395">
        <div className="text-center mb-16" data-id="element-12396">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-12397">
            What Early Teachers Are Saying
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-12398">
            Hear from music educators already excited about MaestroConnect
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-12399">
          {testimonials.map((testimonial, index) => <div key={index} className={`bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20 transition-all duration-700 delay-${index * 100} ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-12400">
              <QuoteIcon className="h-8 w-8 text-deep-pink mb-4 opacity-80" data-id="element-12401" />
              <p className="text-white text-lg italic mb-6" data-id="element-12402">
                {testimonial.quote}
              </p>
              <div data-id="element-12403">
                <p className="font-bold text-white" data-id="element-12404">{testimonial.name}</p>
                <p className="text-gray-300 text-sm" data-id="element-12405">{testimonial.title}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};